import { useLocation, useNavigate, useNavigationType } from 'react-router'
import { SetupMFAWebAuthn } from 'mfa'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { useSetupMFAWebAuthn } from '../../hooks/useSetupMFAWebAuthn'
import { useSettings } from '../../hooks/useSettings'
import { useInitialization } from '../../contexts/Initialization'
import { getInitialSettings } from '../../utils/getInitialSettings'
import {
  LEARN_MORE_ABOUT_SECURITY_KEYS,
  ROOT,
  SETTINGS_PAGE,
} from '../../constants/links'
import { SECURITY_KEY, SECURITY_KEY_ANIMATION } from '../../constants/images'

function SetupMFAWebAuthnWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()
  const { user } = useInitialization() || {}
  const isFromSettings = location.state?.isFromSettings ?? false
  const {
    step,
    isProcessing,
    errorCode,
    registrationData,
    credential,
    prepare,
    finish,
  } = useSetupMFAWebAuthn({ isFromSettings })
  const { addMechanism } = useSettings(getInitialSettings(user))

  return (
    <SetupMFAWebAuthn
      location={location}
      history={{ action: navigationType }}
      step={step}
      isFromSettings={isFromSettings}
      rootPath={ROOT}
      settingsPath={SETTINGS_PAGE}
      isProcessing={isProcessing}
      errorCode={errorCode}
      registrationData={registrationData}
      credential={credential}
      learnMoreAboutSecurityKeysUrl={LEARN_MORE_ABOUT_SECURITY_KEYS}
      securityKeyUrl={SECURITY_KEY}
      securityKeyAnimationUrl={SECURITY_KEY_ANIMATION}
      onCancel={() => navigate(-1)}
      onPrepareRegistration={prepare}
      onStartRegistration={() => {}}
      onFinishRegistration={async ({ credential: c }) => {
        const success = await finish({ registrationData, credential: c })
        if (success) addMechanism('webauthn')
      }}
    />
  )
}

export default withCenteredBaseWithMenu(SetupMFAWebAuthnWrapper)
